import { useContext, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import ajax from '../utils/ajaxHelper';
import { getCompanyId, getHostType, getClientSignupDetailsId } from '../utils';
import { AUTH_EVENTS } from '../constants/actionTypes';
import { ValidateSettingsContext } from '../contexts/ValidateSettingsContext';

const useValidateSettings = () => {
  const { roleId } = useParams();
  const [validateSettingsState, validateSettingsDispatch] = useContext(ValidateSettingsContext);

  const validateSettings = useCallback(async () => {
    const clientSignupDetailsId =
      roleId === 'solo-client' ? { clientSignupDetailsId: getClientSignupDetailsId() } : {};
    try {
      validateSettingsDispatch({ type: AUTH_EVENTS.VALIDATE_REQUEST });
      const companyId = getCompanyId();
      const res = await ajax.post(
        'validateOnBoardingSettings',
        {
          companyId,
          ...clientSignupDetailsId,
        },
        {
          networkParams: { showLoader: false },
          headers: {
            hosttype: getHostType(roleId),
          },
        },
      );

      const array = [...res.onBoardingData];
      array.shift();
      validateSettingsDispatch({
        type: AUTH_EVENTS.VALIDATE_SUCCESS,
        payload: array,
      });
    } catch (error) {
      validateSettingsDispatch({ type: AUTH_EVENTS.VALIDATE_FAIL, payload: error });
    }
  }, [validateSettingsDispatch, roleId]);

  const updateSettings = useCallback(
    async (value) => {
      const path = value.replace(/[^a-zA-Z ]/g, '');
      const array = [...validateSettingsState.data]; // make a separate copy of the array
      const index = array.indexOf(path);

      if (index !== -1) {
        array.splice(index, 1);
        validateSettingsDispatch({
          type: AUTH_EVENTS.VALIDATE_SUCCESS,
          payload: array,
        });
      }
    },
    [validateSettingsState, validateSettingsDispatch],
  );

  return {
    validateSettings,
    updateSettings,
    validateSettingsState,
  };
};

export default useValidateSettings;
